export default __webpack_public_path__ + "static/media/successIcon.35cd8e8e.svg";